import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultMethodResource,
    MethodMutationResourceSchema,
    MethodPropertyValidation,
    useMethodActions,
} from '../../../../../resource/resources/artifacts/method/methodResource';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { SingleParentedOverviewComponent } from '../../../../reusable-components/resource-overviews/SingleParentedOverviewComponent';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { MethodContent } from './MethodContent';

const MethodOverviewContent = ({ id, displayedInOverview }: { id: string; displayedInOverview: boolean }) => {
    const readOnly = useSelector(selectReadOnly);

    const methodActions = useMethodActions();
    const methodQuery = methodActions.useGetResource(id);
    const updateMethod = methodActions.useUpdateResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: MethodMutationResourceSchema,
        defaultValues: defaultMethodResource,
        submitHandler: async (data) => {
            await updateMethod.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: methodQuery.data,
    });

    return (
        <QueryBaseComponent name="Method" query={methodQuery}>
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                <MethodContent
                    displayedInOverview={displayedInOverview}
                    form={form}
                    formNames={formNames}
                    readOnly={readOnly}
                    id={id}
                />
            </Form_DisplayComponentBaseView>
        </QueryBaseComponent>
    );
};

export const MethodOverviewComponent = ({ parentId }: { parentId: string }) => {
    const validationScope = useSelector(selectNoScopeValidationScope);

    const methodActions = useMethodActions();

    const parametersQuery = methodActions.useGetAllResources(parentId);

    const resourceType = ResourceType.METHOD;

    return (
        <QueryBaseComponent name="Methods" query={parametersQuery}>
            <SingleParentedOverviewComponent
                label={'Methods'}
                resourceQuery={parametersQuery}
                content={(id, displayedInOverview) => (
                    <MethodOverviewContent id={id} displayedInOverview={displayedInOverview} />
                )}
                propertyValidationInformation={{
                    namePropertyIdentifier: MethodPropertyValidation.NAME,
                    resourceType,
                }}
                validationScope={validationScope}
                parentId={parentId}
            />
        </QueryBaseComponent>
    );
};
